import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Modal, Table } from "react-bootstrap";
//import { createDevice } from "../services/createDevice";
import Box from "@mui/material/Box";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import Select from "react-select";
import { environment } from "../../../environment";
import CustomListDropDown from "../../Components/CustomListDropDown";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Country, State, City } from "country-state-city";
import Multiselect from "multiselect-react-dropdown";
import { Redirect } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
  box_no,
} from "react-country-region-selector";
import { useEffect } from "react";
// import { Tabs, Tab } from "react-bootstrap-tabs";
import { Tabs, Tab } from "react-bootstrap";
import Container, { TableContainer, TextField } from "@mui/material";
import { SurveyQuestionPanelDynamicItem } from "survey-react-ui";

const MySwal = withReactContent(Swal);

const PartnerEditShipment = ({ history, match, props }) => {
  const [carton_no, setcartonno] = useState("");
  const [awb_no, setawbno] = useState("");
  const [box_no, setboxno] = useState("");
  const [date, setdate] = useState(new Date().toLocaleDateString());
  const [show, setShow] = useState(false);
  const [isAddProduct, setAddProduct] = useState(false);
  const [dap_consignees, setDapConsignees] = useState([]);
  const [consignee_details, setConsigneeDetails] = useState({});
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [boxId, setboxId] = useState("");
  const [boxtype, setboxtype] = useState("");
  const [name, setname] = useState("");
  const [deviceIdMongo, setdeviceIdMongo] = useState("");
  const [consigneeid, setconsigneeid] = useState("");
  const [currentTab, setCurrentTab] = useState(0);
  const [nameErrors, setNameErrors] = useState({});
  const [inventoryError, setInventoryError] = useState({});
  const [boxes, setboxes] = useState([]);
  const [zip, setzip] = useState("");
  const [tabledata, settabledata] = useState([]);
  const [inputfields, setInputFields] = useState([
    {
      deviceIdMongo: "",
      deviceName: "",
      deviceLabel: "",
      deviceVersion: "",
      deviceType: "",
      deviceTypeId: "",
      accessToken: "",
    },
  ]);
  const [consignee_type, setConsigneeType] = useState("");
  const [showdevices, setShowDevices] = useState(false);
  const [devices, setDevices] = useState([]);
  const [devicesArray, setDevicesArr] = useState([]);
  const [disableAddBox, setDisableAddBox] = useState(true);
  const [myoptions, setMyOptions] = useState({
    id: consignee_details._id,
    label: consignee_details.userFirstName + " " + consignee_details.userLastName,
    value: consignee_details.id,
  })

  // const [boxdetails, setboxDetails] = useState([
  //   {
  //     shipmentIdMongo: "",
  //     boxQr: "",
  //     shipmentDevices: inputfields,
  //   },
  // ]);
  // useEffect(() => {
  //   let id = match.params.id;
  //   console.log(id);
  //   getShipmentData(id);
  // }, []);

  const getShipmentData = (id) => {
    axios
      .get(environment.dap_url + "shipmentApi/getByIdWithLogs?_id=" + id)
      .then((res) => {
        console.log("ankit")
        console.log(res.data.shipmentDetails[0]);
        setConsigneeDetails(res.data.shipmentDetails[0].consigneedetails[0]);
        setAddress(res.data.shipmentDetails[0].address);
        setPhone(res.data.shipmentDetails[0].phone);
        setPostCountry(res.data.shipmentDetails[0].consignmentCountry);
        setPostCity(res.data.shipmentDetails[0].consignmentCity);
        setPostState(res.data.shipmentDetails[0].consignmentState);
        setconsigneeid(res.data.shipmentDetails[0].consigneedetails[0]._id);
        setConsigneeType(
          res.data.shipmentDetails[0].consigneedetails[0].userType
        );
        setEmail(res.data.shipmentDetails[0].consigneedetails[0].email);
        setname(
          res.data.shipmentDetails[0].consigneedetails[0].userFirstName + " " +
          res.data.shipmentDetails[0].consigneedetails[0].userLastName
        );
        setcartonno(res.data.shipmentDetails[0].cartonQr);
        setzip(res.data.shipmentDetails[0].consigneedetails[0].zip);
        setMyOptions(
          res.data.shipmentDetails[0].consigneedetails[0].userFirstName + " " +
        res.data.shipmentDetails[0].consigneedetails[0].userLastName
        );
        // setboxes(res.data.shipmentDetails[0].shipmentBoxes)
        let arr = [];
        let boxDetails = {};
        let b_qr;
        let key = 0;
        let singleBoxArr = [];
        let singleBox = {};
        let boxArr = [];
        let shipmentIdMongo;
        let deviceArr = [];
        /*junk code
        res.data.shipmentDetails[0].shipmenboxes.forEach((element) => {
          console.log("element",element);
          // console.log("break");
          b_qr = element.boxQr;
          deviceArr = [];
          element.shipmentDevices.forEach((d) => {
            console.log("device",d);
            deviceArr.push({
              deviceIdMongo: d.deviceIdMongo,
              deviceName: d.deviceName,
              deviceLabel: d.deviceLabel,
              deviceVersion: d.deviceVersion,
              deviceType: d.deviceType,
              deviceTypeId: d.deviceTypeId,
              accessToken: d.accessToken,
            });
          });

          axios
            .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + b_qr)
            .then((res) => {
              console.log("boxlabel",res.data);
              setNameErrors({});
              boxDetails.boxType = res.data.BoxType;
              boxDetails.boxLable = b_qr;
              singleBox = {
                shipmentIdMongo: element.shipmentIdMongo,
                boxQr: element.boxQr,
                shipmentDevices: deviceArr,
              };
              console.log("singleBox",singleBox);
              boxArr.push(singleBox);
              singleBoxArr.push(boxDetails);
            })
            .catch(function (error) {
              formValidationBox();
              console.log(error.message);
              // return {"id":"","type":""};
            });

          
        });
        console.log("deviceArr",deviceArr)
        // console.log("single box",singleBoxArr);
        // settabledata(singleBoxArr);
        // setboxes(boxArr);*/
        let boxAr = []
        let tableDataAr = []
        res.data.shipmentDetails[0].shipmenboxes.forEach(box => {
          let deviceAr = {};
          let boxQr = box.boxQr;
          let tableData = {
            boxLable: box.boxQr,
            boxType: '',
          }
          axios
            .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + boxQr)
            .then((res) => {
              console.log(res.data);
              tableData.boxType = res.data.boxType
              let singleBox = {
                shipmentIdMongo: box.shipmentIdMongo,
                boxQr: box.boxQr,
                shipmentDevices: [],
              };

              box.shipmentDevices.forEach(device => {
                deviceAr = {
                  deviceIdMongo: device.deviceIdMongo,
                  deviceName: device.deviceName,
                  deviceLabel: device.deviceLabel,
                  deviceVersion: device.deviceVersion,
                  deviceType: device.deviceType,
                  deviceTypeId: device.deviceTypeId,
                  accessToken: device.accessToken,
                }
              })
              singleBox.shipmentDevices.push(deviceAr)
              boxAr.push(singleBox);
              tableDataAr.push(tableData)
            })
            .catch(function (error) {
              formValidationBox();
              console.log(error.message);
              // return {"id":"","type":""};
            });




        })
        console.log(boxAr);
        setboxes(boxAr)
        settabledata(tableDataAr)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submit = () => {

    if (
      boxes.length === 0
    ) {
      MySwal.fire({
        title: "Shipment is empty. Please add boxes",
        type: "error",
        icon: "error"
      });
      return;
    }

    let userdetails = JSON.parse(localStorage.getItem("userDetails"));
    let id = match.params.id;
    let req = {
      // consignorId: userdetails.data.id.id,
      // logisticId: userdetails.data.id.id,
      consigneeId: consigneeid,
      consignmentCity: postcity,
      consignmentState: poststate,
      consignmentCountry: postcountry,
      cartonQr: carton_no,
      name: name,
      zip: zip,
      email: email,
      address: address,
      phone: phone,
      notes: "",
      boxList: boxes,
    };
    console.log(req);
    axios
      .put(environment.dap_url + "shipmentApi/updateShipment?id=" + id, req)
      .then((res) => {
        MySwal.fire({
          title: <p>Shipment Updated</p>,
          type: "success",
        });
        history.push("/myshipments");
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: <p>{err?.response?.data?.message}</p>,
          type: "error",
        });
      });
  };
  const formValidationBox = () => {
    const nameErrors = {};
    let isValid = true;
    nameErrors.noName = "Doesn't seem like a box ";
    isValid = false;
    setNameErrors(nameErrors);
    return isValid;
  };
  const formValidationInventory = () => {
    const inventoryError = {};
    let isValid = true;
    inventoryError.nodevice = "This Device is Not Presenet in Inventory";
    isValid = false;
    setInventoryError(inventoryError);
    return isValid;
  };
  const handleAddClick = (e) => {
    e.preventDefault();
    setInputFields([
      ...inputfields,
      {
        deviceIdMongo: "",
        deviceName: "",
        deviceLabel: "",
        deviceVersion: "",
        deviceType: "",
        deviceTypeId: "",
        accessToken: "",
      },
    ]);
    console.log("hero");
    console.log(inputfields);
  };
  const setConsigneeAddress = (e) => {
    setconsigneeid(e.value);
    axios
      .get(
        environment.dap_url +
        `shipmentApi/getPartnerDetailsById?consigneeId=` +
        e.value
      )
      .then((res) => {
        setAddress(res.data.address);
        setPhone(res.data.phone);
        console.log(res.data);
        setPostCountry(res.data.country);
        setPostState(res.data.state);
        setPostCity(res.data.city);
        setname(res.data.userFirstName + " " + res.data.userLastName);
        setAddress(res.data.address);
        setEmail(res.data.email);
        setzip(res.data.zip);
        setConsigneeDetails(res.data);
      })
      .catch(function (error) {
        window.alert(error.message);
      });
  };

  useEffect(() => {
    axios
      .get(environment.dap_url + `partnerApi/getAll`)
      .then((res) => {
        console.log(res.data);
        setDapConsignees(res.data);
      })
      .catch(function (error) {
        window.alert(error.message);
      });
    let id = match.params.id;
    getShipmentData(id);
  }, []);

  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  const selectCountry = (e) => {
    console.log("country");
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };
  const handleRemoveClick = (index, e) => {
    e.preventDefault();
    const values = [...inputfields];
    values.splice(index, 1);
    setInputFields(values);
  };
  const handleChangeInput = (index, event) => {
    const myarray = event.target.value.split("|");
    // console.log("myarray", myarray);
    if (myarray.length == 5) {
      scanqr(index, event, myarray);
      onScan(index, event);
    }
    const values = [...inputfields];
    values[index][event.target.name] = event.target.value;
    setInputFields(values);
    if (event.target.name == "deviceLabel") {
      axios
        .get(
          environment.dap_url +
          `shipmentApi/getDeviceDetailsByLabel?deviceLabel=` +
          event.target.value
        )
        .then((res) => {
          setInventoryError({});
          console.log(res.data);
          values[index]["deviceIdMongo"] = res.data._id;
          values[index]["deviceName"] = res.data.deviceName;
          values[index]["deviceTypeId"] = "1234";
        })
        .catch(function (error) {
          formValidationInventory();
          console.log(error.message);
        });
    }
  };
  const onScan = (index, event) => {
    console.log(index, event.target.name);
    let qrvalue = event.target.value;
    let qrCodeArray = qrvalue.split("|");
    const values = [...inputfields];
    // values[index][event.target.value] = qrCodeArray[0];
    console.log(values);
    setInputFields(values);
    // setInputFields([
    //   ...inputfields,
    //   {
    //     deviceType: qrCodeArray[1],
    //     deviceLabel:  qrCodeArray[0],
    //     accessToken:  qrCodeArray[2],
    //     deviceVersion:  qrCodeArray[3],
    //     isInstalled: false,
    //   },
    // ]);
    // values[index][event.target.name] = event.target.value;
  };
  const scanqr = (index, event, myarray) => {
    console.log("QRcodevalue", event.target.value);
    const values = [...inputfields];
    values[index]["deviceLabel"] = myarray[1];
    values[index]["deviceVersion"] = myarray[2];
    values[index]["accessToken"] = myarray[3];
    // values[index]["deviceType"] = myarray[0];
    var el = document.getElementById(index + "deviceType");
    el.value = myarray[0];
    if (myarray[1]) {
      axios
        .get(
          environment.dap_url +
          `shipmentApi/getDeviceDetailsByLabel?deviceLabel=` +
          event.target.value
        )
        .then((res) => {
          setInventoryError({});
          console.log(res.data);
          values[index]["deviceIdMongo"] = res.data._id;
          values[index]["deviceName"] = res.data.deviceName;
          values[index]["deviceTypeId"] = "1234";
        })
        .catch(function (error) {
          formValidationInventory();
          console.log(error.message);
        });
    }
  };
  const handleAddPoduct = () => {
    setAddProduct(true);
  };

  const checkBox = (l) => {
    let boxArr = l.split('|')
    console.log(boxes);
    let label = '';
    if (boxArr.length > 1 && boxArr.length <= 5) {
      console.log("scan");
      label = boxArr[1]
      console.log(boxes.length);
      if (boxes.length > 0) {
        boxes.every(box => {
          console.log(box);
          console.log(box.boxQr == label);
          if (box.boxQr == label) {
            setNameErrors({ noName: "Box is already present in the shipment" })
            console.log("box is already present");
            setDisableAddBox(true);
            return false;
          } else {
            setNameErrors({})
            setDisableAddBox(false);
            axios
              .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + label)
              .then((res) => {
                console.log(res.data);
                setboxId(res.data._id);
                setboxtype(res.data.boxType);
                return true
              })
              .catch(function (error) {
                formValidationBox();
                console.log(error.message);
                setDisableAddBox(true)
                return false
              });
          }
          // if(box.boxQr == label)
          //   return false
          return true;
        });
      } else {
        setNameErrors({})
        axios
          .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + label)
          .then((res) => {
            console.log(res.data);
            setboxId(res.data._id);
            setboxtype(res.data.boxType);
            setDisableAddBox(false)
          })
          .catch(function (error) {
            formValidationBox();
            console.log(error.message);
            setDisableAddBox(true)
          });
      }


    } else {
      setNameErrors({})
      console.log("manual");
      label = l
      console.log(boxes.length);
      if (boxes.length > 0) {
        boxes.every(box => {
          console.log(box);
          console.log(box.boxQr == label);
          if (box.boxQr == label) {
            setNameErrors({ noName: "Box is already present in the shipment" })
            console.log("box is already present");
            setDisableAddBox(true);
            return false;
          } else {
            setNameErrors({})
            setDisableAddBox(false);
            axios
              .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + label)
              .then((res) => {
                console.log(res.data);
                setboxId(res.data._id);
                setboxtype(res.data.boxType);
                return true
              })
              .catch(function (error) {
                formValidationBox();
                console.log(error.message);
                setDisableAddBox(true)
                return false
              });
          }
          // if(box.boxQr == label)
          //   return false
          return true;
        });
      } else {
        setNameErrors({})
        axios
          .get(environment.dap_url + `boxApi/checkIsBox?deviceLabel=` + label)
          .then((res) => {
            if (res.status == 200) {
              setboxId(res.data._id);
              setboxtype(res.data.BoxType);
              setNameErrors({});
              setDisableAddBox(false);
            } else if (res.status == 201) {
              setNameErrors({ noName: "Box is in used" })
              setDisableAddBox(true);
            } else {
              setNameErrors({ noName: "Not A Box.Please Scan A Box" })
              setDisableAddBox(true);
            }
          })
          .catch(function (error) {
            formValidationBox();
            console.log(error.message);
            setDisableAddBox(true)
          });
      }


    }
    setboxno(label)

  };
  const data = [];

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let boxlist = [];

  const removeShipmentBox = (index, event) => {
    event.preventDefault();
    const tableData = [...tabledata];
    tableData.splice(index, 1);
    settabledata(tableData);
    const boxesData = [...boxes];
    console.log(boxes);
    boxesData.splice(index, 1);
    setboxes(boxesData);

  };

  const PushData = () => {
    // console.log(boxes);

    setInventoryError({})
    let singleBox = {};
    let boxDetails = {};

    checkBox(box_no)
    singleBox.shipmentIdMongo = boxId;
    singleBox.boxQr = box_no;
    singleBox.shipmentDevices = inputfields;
    console.log(singleBox.shipmentDevices);
    console.log(singleBox);
    let flag = false;
    singleBox.shipmentDevices.forEach(devices => {
      if (
        devices.deviceLabel == "" ||
        // devices.deviceVersion == "" ||
        devices.deviceType == ""
        //|| devices.accessToken == ""
      ) {
        setInventoryError({ error: "Please fill a valid device" })
        flag = true;
      }
    })
    console.log(flag);
    if (!flag) {
      boxDetails.boxType = boxtype;
      boxDetails.boxLable = box_no;
      console.log(boxDetails);
      settabledata([...tabledata, boxDetails]);
      setboxes([...boxes, singleBox]);
      handleClose();
      setboxId("");
      setboxno("");
      setAddProduct(false);
      setInputFields([
        {
          deviceIdMongo: "",
          deviceName: "",
          deviceLabel: "",
          deviceVersion: "",
          deviceType: "",
          deviceTypeId: "",
          accessToken: "",
        },
      ]);
    }

    console.log(consignee_details);


  };

  const handleShowDevices = (key, event) => {
    console.log(boxes[key].shipmentDevices);
    setDevices(boxes[key].shipmentDevices);
    setShowDevices(true);
  };

  const handleCloseDevices = () => {
    console.log(devicesArray);
    setShowDevices(false);
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Link to="/myshipments" className="btn btn-light my-3">
              Go Back
            </Link>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col-lg-3"></div>
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <h3 className="text-center">EDIT Shipment</h3>
                <div className="card-body">
                  <Tabs activeKey={currentTab}>
                    <Tab eventKey={0} title="Basics Details">
                      <div className="row">
                        <div className="col-md-4">
                          <Form.Group controlId="consignee">
                            <Form.Label>Consignee </Form.Label>
                            <Select
                              options={dap_consignees.map((dap_consignee) => ({
                                id: dap_consignee._id,
                                value: dap_consignee._id,
                                label:
                                  dap_consignee.userFirstName +
                                  " " +
                                  dap_consignee.userLastName,
                              }))}
                              value={{
                                id: consignee_details._id,
                                label: consignee_details.userFirstName + " " + consignee_details.userLastName,
                                value: consignee_details.id,
                              }}
                              onChange={(e) => setConsigneeAddress(e)}
                              placeholder={"Consignee"}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Name"
                              value={name}
                              onChange={(e) => setname(e)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-4">
                          <Form.Group controlId="countri">
                            <Form.Label>Country</Form.Label>
                            <Select
                              onChange={(e) => setPostCountry(e)}
                              placeholder="Country"
                              value={{
                                id: "",
                                label: postcountry,
                                value: postcountry,
                              }}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-4">
                          <Form.Group controlId="name">
                            <Form.Label>State</Form.Label>
                            <Select
                              onChange={(e) => setPostState(e)}
                              // defaultValue={dap_deviceList[0].name}
                              value={{
                                id: "",
                                label: poststate,
                                value: poststate,
                              }}
                              placeholder="State"
                            />
                          </Form.Group>
                        </div>

                        <div className="col-4">
                          <Form.Group controlId="name">
                            <Form.Label>City</Form.Label>
                            <Select
                              onChange={(e) => setPostCity(e)}
                              // defaultValue={dap_deviceList[0].name}
                              // defaultValue="hi there"
                              value={{ label: postcity, value: postcity }}
                              placeholder="City"
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Address"
                              value={address}
                              onChange={(e) => setAddress(e)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        {/* <div className="col-md-4">
                          <Form.Group controlId="">
                            <Form.Label>Zip</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Address"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div> */}
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="address">
                            <Form.Label>Zip Code</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone"
                              value={zip}
                              onChange={(e) => setzip(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group controlId="carton">
                            <Form.Label>Carton No.</Form.Label>
                            <Form.Control
                              type="carton"
                              placeholder="Enter Carton No."
                              value={carton_no}
                              onChange={(e) => setcartonno(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Button
                            className="success"
                            onClick={() => setCurrentTab(1)}
                            style={{ marginTop: 25, float: "left" }}
                          >
                            Next
                          </Button>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey={1} title="Products">
                      <Button variant="primary" onClick={handleShow}>
                        Add Box
                      </Button>
                      {/* <div className="row">
                        <div className="col-12">
                          <div className="card">
                            <div className="card-body">
                              <h4 className="card-title">DEVICES</h4>
                              <div className="row">
                                <div className="col-12">
                                  <ToolkitProvider
                                    keyField="id"
                                    bootstrap4
                                    data={boxes}
                                    columns={columns}
                                  ></ToolkitProvider>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <Table striped>
                        <thead>
                          <tr>
                            <th>Box No.</th>
                            <th>Box Name.</th>
                            <th>Box Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tabledata?.map((val, key) => {
                            return (
                              <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{val.boxLable}</td>
                                <td>{val.boxType}</td>
                                <td>
                                  {/* <a
                                    data-mdb-toggle="tooltip"
                                    title="1 Product, 1 Charger"
                                  >
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                  </a> */}
                                  <Button
                                    variant="primary"
                                    className="btn btn-sm"
                                    onClick={(e) => handleShowDevices(key, e)}
                                  >
                                    View
                                  </Button>
                                  <Button
                                    variant="danger"
                                    className="btn btn-sm"
                                    onClick={(e) => removeShipmentBox(key, e)}
                                  >
                                    Delete
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                          <Modal.Title>Box Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="col-md-12">
                            <div className="col-md-8">
                              <Form.Group controlId="box">
                                <Form.Label>Box No.</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="Box No."
                                  value={box_no}
                                  onChange={(e) => checkBox(e.target.value)}
                                ></Form.Control>
                                <div>
                                  {Object.keys(nameErrors).map((key) => {
                                    return (
                                      <div style={{ color: "red" }}>
                                        {nameErrors[key]}
                                      </div>
                                    );
                                  })}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="col-md-6">
                              <Button
                                variant="primary"
                                onClick={handleAddPoduct}
                                disabled={disableAddBox}
                              >
                                Add Product
                              </Button>
                            </div>
                          </div>
                          {isAddProduct ? (
                            <div className="row">
                              <TableContainer>
                                {inputfields.map((inputField, index) => (
                                  <div key={index}>
                                    <TextField
                                      name="deviceType"
                                      label="Product Category"
                                      // variant="filled"
                                      id={index + "deviceType"}
                                      style={{
                                        margin: 5,
                                      }}
                                      value={inputField.deviceType}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                    />
                                    <TextField
                                      name="deviceLabel"
                                      label="Label"
                                      // variant="filled"
                                      style={{
                                        margin: 5,
                                      }}
                                      value={inputField.deviceLabel}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                    />
                                    <TextField
                                      name="deviceVersion"
                                      label="Version"
                                      // variant="filled"
                                      style={{
                                        margin: 5,
                                      }}
                                      value={inputField.deviceVersion}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                    />
                                    <TextField
                                      name="accessToken"
                                      label="Access Token"
                                      // variant="filled"
                                      style={{
                                        margin: 5,
                                      }}
                                      value={inputField.accessToken}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                    />
                                    <button
                                      className="btn btn-primary btn-sm"
                                      style={{
                                        margin: 10,
                                      }}
                                      onClick={(e) => handleAddClick(e)}
                                    >
                                      Add More
                                    </button>
                                    <button
                                      className="btn btn-danger btn-sm"
                                      style={{
                                        margin: 10,
                                      }}
                                      onClick={(e) =>
                                        handleRemoveClick(index, e)
                                      }
                                    >
                                      Remove
                                    </button>

                                  </div>
                                ))}
                              </TableContainer>
                            </div>
                          ) : (
                            ""
                          )}
                        </Modal.Body>
                        <Modal.Footer>
                          <div>
                            {Object.keys(inventoryError).map(
                              (key) => {
                                return (
                                  <div style={{ color: "red" }}>
                                    {inventoryError[key]}
                                  </div>
                                );
                              }
                            )}
                          </div>
                          <Button variant="danger" onClick={handleClose}>
                            Close
                          </Button>
                          <Button variant="primary" onClick={PushData}>
                            Confirm
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <Modal show={showdevices} onHide={handleCloseDevices}>
                        <Modal.Header closeButton>
                          <Modal.Title>Box Assets</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                {/* <th scope="col">Device Name</th> */}
                                <th scope="col">Device Label</th>
                                <th scope="col">Device Version</th>
                              </tr>
                            </thead>
                            <tbody>
                              {devices?.map((val, key) => {
                                return (
                                  <tr key={key}>
                                    <td>{key + 1}</td>
                                    {/* <td>{val.deviceName}</td> */}
                                    <td>{val.deviceLabel}</td>
                                    <td>{val.deviceVersion}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="danger" onClick={handleCloseDevices}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <Button
                        className="success"
                        style={{ float: "right", margin: 10 }}
                        onClick={() => setCurrentTab(0)}
                      >
                        Prev
                      </Button>
                      <Button
                        className="success"
                        style={{ float: "right", margin: 10 }}
                        onClick={() => submit()}
                      >
                        Save
                      </Button>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnerEditShipment;
